module.exports = __webpack_public_path__ + "1791188489487/fonts/Flaticon.3d1170b.woff";